import { useCallback } from 'react'
import useSWR from 'swr'
import { useContactAuthentication } from '../contactAuth/hooks'
import { nocoSDK } from '../initialize'
import { SWRCachePath } from '../swr-cach-path'

// site 情報を返す
export const useGetContactSite = (siteId: string) => {
  const { data: auth } = useContactAuthentication()
  const siteApi = nocoSDK.client?.contactService.siteApi
  const visitorApi = nocoSDK.client?.contactService.visitorApi
  const func = useCallback(async () => {
    if (!auth || !auth.token) {
      console.warn('getContactDocument: no contact token')
      return
    }

    // visitor と contact が結びついていない限り document は取得ができないので存在チェックをしている
    const res = await visitorApi?.ApiFactory(auth.token).contactV1VisitorGet({ xNocoVisitorToken: auth.token })
    const visitor = res?.data?.visitor
    if (!visitor) {
      console.warn('getContactDocument: insufficient visitor information', visitor)
      return
    }
    return await siteApi
      ?.ApiFactory(auth.token)
      .contactV1SitesSiteIdGet({ siteId })
      .then(item => item.data)
  }, [auth, siteApi, siteId, visitorApi])

  return useSWR(auth && SWRCachePath.getContactDocument(siteId), func)
}

// site 情報を返す
// link 共有の時に利用する api
export const useGetContactSiteShare = (shareId: string) => {
  const { data: auth } = useContactAuthentication()
  const siteApi = nocoSDK.client?.contactService.siteApi
  const func = useCallback(async () => {
    if (!auth || !auth.token) {
      console.warn('contact site share: no contact token')
      return
    }
    const res = await siteApi?.ApiFactory(auth.token).contactV1SitesSharePublicLinkUlidGet({ publicLinkUlid: shareId })
    return res?.data
  }, [auth, shareId, siteApi])

  return useSWR(auth && SWRCachePath.getContactSiteShare(shareId), func)
}

export const useGetContactSiteShareForm = (siteShareId: string) => {
  const { data: auth } = useContactAuthentication()
  const siteApi = nocoSDK.client?.contactService.siteApi
  const visitorApi = nocoSDK.client?.contactService.visitorApi
  const func = useCallback(async () => {
    if (!auth || !auth.token) {
      console.warn('getContactDocument: no contact token')
      return
    }
    // visitor と contact が結びついていない限り document は取得ができないので存在チェックをしている
    const res = await visitorApi?.ApiFactory(auth.token).contactV1VisitorGet({ xNocoVisitorToken: auth.token })
    const visitor = res?.data?.visitor
    if (!visitor || !visitor.hasContact) {
      console.warn('getContactSite: insufficient visitor information', visitor)
      return
    }
    return await siteApi
      ?.ApiFactory(auth.token)
      .contactV1SitesSharePublicLinkUlidShareFormsGet({
        publicLinkUlid: siteShareId
      })
      .then(item => item.data)
  }, [auth, siteApi, siteShareId, visitorApi])

  return useSWR(auth && SWRCachePath.getContactSiteShareForm(siteShareId), func)
}
